require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./naturstein-bearbeitung.json") })
        }
      }, "path---naturstein-bearbeitung");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---naturstein-bearbeitung!./.cache/json/naturstein-bearbeitung.json
// module id = 460
// module chunks = 231608221292675